import React, { useEffect, useRef, useState } from 'react'
import { useLanguage } from '../../../../LanguageProvider';
import { CgCloseO } from 'react-icons/cg';
import { GrAttachment } from 'react-icons/gr';
import { IoCloseOutline, IoDocumentTextOutline } from 'react-icons/io5';
import AddModalInputField from '../../../../components/AddModalInputField/AddModalInputField';
import { TbStack2 } from 'react-icons/tb';
import './AddSpeakerModal.css'
import { useToaster } from '../../../../ToasterProvider';

export default function AddSpeakerModal({
    isOpen,
    onClose,
    onCreate
}) {
    const { toastWarning } = useToaster();
    const fileInputRef = useRef();
    const { getTranslation } = useLanguage();
    const [name, setName] = useState("");
    const [lastname, setLastname] = useState("");
    const [title, setTitle] = useState("");
    const [linkedin, setLinkedin] = useState("");
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [speakingAboutTitle, setSpeakingAboutTitle] = useState("");
    const [speakingAbout, setSpeakingAbout] = useState("");

    const resetStates = () => {
        setName("");
        setLastname("");
        setTitle("")
        setLinkedin("")
        setSelectedFiles([])
        setSpeakingAboutTitle("")
        setSpeakingAbout("")
    }

    useEffect(() => {
        if (!isOpen) {
            resetStates();
        }
    }, [isOpen]);

    if (!isOpen) return null;


    const handleClose = () => {
        onClose();
        resetStates()
    }

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.split(",")[1]; // "data:image/jpeg;base64," kısmını kaldırıyoruz
                const extension = file.name.split(".").pop();
                const title =
                    file?.name?.substring(0, file.name.lastIndexOf(".")) || file?.name;
                setSelectedFiles((prevFiles) => [
                    ...prevFiles,
                    { file: base64String, extension: extension, title: title },
                ]);
            };
            reader.readAsDataURL(file);
        });
    };

    const removeFile = (index) => {
        setSelectedFiles((prevFiles) => prevFiles.filter((file, i) => i !== index));
    };

    const allFieldsAreValid = () => {
        return (
            name.trim() !== "" &&
            lastname.trim() !== "" &&
            title.trim() !== "" &&
            speakingAboutTitle.trim() !== "" &&
            speakingAbout.trim() !== "" &&
            selectedFiles.length > 0
        );
    };

    const handleCreate = () => {
        if (!allFieldsAreValid()) {
            toastWarning(getTranslation("pleaseFillAllFields"))
        }
        else {
            onCreate(name, lastname, title, selectedFiles[0], speakingAboutTitle, speakingAbout, linkedin)
        }
    }



    return (
        <div className="add-speaker-modal-overlay">
            <div className="add-speaker-modal-container">
                <IoCloseOutline
                    className="add-speaker-modal-button close"
                    onClick={handleClose}
                />

                <p className="add-speaker-modal-title">
                    {getTranslation("addNewSpeaker")}
                </p>

                <AddModalInputField
                    icon={<TbStack2 size={22} style={{ width: "25px" }} />}
                    placeholder={getTranslation("name") + "*"}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    type={"text"}
                />

                <AddModalInputField
                    icon={<TbStack2 size={22} style={{ width: "25px" }} />}
                    placeholder={getTranslation("lastname") + "*"}
                    value={lastname}
                    onChange={(e) => setLastname(e.target.value)}
                    type={"text"}
                />

                <AddModalInputField
                    icon={<TbStack2 size={22} style={{ width: "25px" }} />}
                    placeholder={getTranslation("position") + "*"}
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    type={"text"}
                />

                <AddModalInputField
                    icon={<TbStack2 size={22} style={{ width: "25px" }} />}
                    placeholder={getTranslation("speakingAboutTitle") + "*"}
                    value={speakingAboutTitle}
                    onChange={(e) => setSpeakingAboutTitle(e.target.value)}
                    type={"text"}
                />

                <div className="add-task-modal-content">
                    <IoDocumentTextOutline
                        size={20}
                        style={{
                            width: "25px",
                            alignSelf: "flex-start",
                            marginTop: "10px",
                        }}
                    />
                    <textarea
                        className="add-task-modal-textarea"
                        style={{ height: '150px' }}
                        placeholder={getTranslation("speakingAbout") + "*"}
                        value={speakingAbout}
                        onChange={(e) => { setSpeakingAbout(e.target.value); }} />
                </div>

                <AddModalInputField
                    icon={<TbStack2 size={22} style={{ width: "25px" }} />}
                    placeholder={"LinkedIn"}
                    value={linkedin}
                    onChange={(e) => setLinkedin(e.target.value)}
                    type={"text"}
                />

                <div
                    style={{
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "6px",
                        display: "flex",
                    }}
                >
                    <span
                        style={{
                            width: "100%",
                            flexDirection: "row",
                            alignItems: "center",
                            display: "flex",
                            gap: "5px",
                        }}
                    >
                        <span className="add-event-modal-attachments-icon">
                            <GrAttachment />
                        </span>
                        <span className="add-event-modal-attachments">
                            {getTranslation("avatar")}
                        </span>
                    </span>
                    <div className="add-event-modal-select-file-holder">
                        <button
                            className="action-button"
                            onClick={() => fileInputRef.current.click()}
                        >
                            {getTranslation("selectFile")}
                        </button>
                        <input
                            type="file"
                            accept=".png,.jpg,.jpeg,.gif"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                        />

                    </div>


                    {selectedFiles.length > 0 && (
                        <div
                            style={{
                                display: "flex",
                                overflowX: "auto",
                                gap: "8px",
                                padding: "8px 0",
                                width: "100%",
                            }}
                        >
                            {selectedFiles.map((file, index) => (
                                <div
                                    className="add-event-modal-added-attachment-chip"
                                    key={index}
                                >
                                    <span className="add-event-modal-added-attachment-chip-title">
                                        {file.title}
                                    </span>
                                    <CgCloseO
                                        onClick={() => removeFile(index)}
                                        style={{
                                            cursor: "var(--pointer)",
                                            minWidth: "14px",
                                            minHeight: "14px",
                                            width: "14px",
                                            height: "14px",
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    )}

                </div>



                <div className="add-speaker-modal-actions">
                    <button
                        className="add-speaker-modal-button create"
                        onClick={handleCreate}
                    >
                        {getTranslation("create")}
                    </button>
                </div>
            </div>
        </div>
    );
}
